import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedRoutingModule } from './shared-routing.module';
import { ImageCroppedWrappedComponent } from './components/image-cropped/image-cropped.component';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {TooltipModule} from 'primeng/tooltip';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ImageModule } from 'primeng/image';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputTextareaModule } from 'primeng/inputtextarea';
import {CheckboxModule} from 'primeng/checkbox';
import { TimeAgoPipe } from './Pipes/time-ago.pipe';

import { AudioPlayerComponent } from './components/audio-player/audio-player.component';
import { VoiceRecorderComponent } from './components/voice-recorder/voice-recorder.component';

const modulos = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    ButtonModule,
    DialogModule,
    AvatarGroupModule,
    ImageModule,
    OverlayPanelModule,
    InputTextareaModule,
    CheckboxModule,
    TooltipModule
];

const components = [
  // ImageCroppedComponent,
  AudioPlayerComponent,
  VoiceRecorderComponent,
  TimeAgoPipe
];

@NgModule({
  declarations: components,
  imports: modulos,
  exports: [
    ...modulos,
    ...components
  ]
})
export class SharedModule { }
